// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"EspecialidadesGer_containerPrincipal__sZHWB","divEspecialidades":"EspecialidadesGer_divEspecialidades__+Fgij","divTitulo":"EspecialidadesGer_divTitulo__914MS"};